import React from 'react'
import { LntBadge } from '@app/components/base'

import variables from '@app/theme/variables'

export const BadgeAccessRender: React.FC<{ hasAccess?: boolean }> = ({ hasAccess }) => {
  const color = hasAccess ? variables.successGreen : variables.dangerRed
  const text = hasAccess ? 'Доступен' : 'Недоступен'

  return (
    <LntBadge
      color={ color }
      text={ text }
    />
  )
}
